import { render, staticRenderFns } from "./QueuesHealthCard.vue?vue&type=template&id=5779b66d"
import script from "./QueuesHealthCard.vue?vue&type=script&lang=js"
export * from "./QueuesHealthCard.vue?vue&type=script&lang=js"
import style0 from "./QueuesHealthCard.vue?vue&type=style&index=0&id=5779b66d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports